//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SameProductCard from '~/components/product/add-to-cart/SameProductCard.vue'
export default {
  name: 'SameProducts',
  props: {
    sameProducts: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    SameProductCard
  },
  data() {
    return {
      isShowMore: Boolean(false),
    }
  },
  computed: {
    visibleShowMoreButton : function() {
      return Boolean(this.sameProducts.length > 2);
    },
    preparingSameProducts: function() {
      if (this.sameProducts && !this.isShowMore) {
        return this.sameProducts.slice(0, 2);
      }
      return this.sameProducts;
    },
    labelShowMoreButton: function() {
      if (this.visibleShowMoreButton && !this.isShowMore) {
        return `Посмотреть все  ${this.sameProducts.length} ${ this.$caseWords(this.sameProducts.length, ['товар', 'товара', 'товаров']) }`
      }
      if (this.visibleShowMoreButton && this.isShowMore) {
        return `Скрыть`
      }
    }
  },
  methods: {
    showMoreToggle: function() {
      this.isShowMore = !this.isShowMore;
    },
  }
}
